export default function CsharpTypeConversion() {
  return (
    <h2>Csharp Type Conversion</h2>
  );
}
